import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/lib/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[var(--ink)] border-t border-white/10 overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 lg:px-10 pt-20 pb-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img src="/images/logo-light.png" alt="Carwash Solar + Batteries" className="h-20 w-auto" />
          <p className="mt-6 max-w-sm text-slate-300 leading-relaxed">
            Carwash Solar Advisers — a proud division of Solar Advisers Australia. Trusted commercial &amp; car wash solar specialists since 2013.
          </p>
        </div>
        <div className="lg:col-span-2">
          <p className="eyebrow mb-5">Pages</p>
          <ul className="space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.id}`} className="text-slate-200 hover:text-[var(--sun)] transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-5 grid sm:grid-cols-2 gap-8">
          {CONTACT.people.map((p) => (
            <div key={p.id}>
              <p className="eyebrow mb-5">{p.role}</p>
              <p className="font-display text-2xl font-bold uppercase">{p.name}</p>
              <a href={p.href} data-testid={`footer-phone-${p.id}`} className="mt-2 flex items-center gap-2 text-slate-200 hover:text-[var(--sun)] transition-colors"><Phone size={14} /> {p.phone}</a>
              <a href={`mailto:${p.email}`} data-testid={`footer-email-${p.id}`} className="mt-1 flex items-center gap-2 text-slate-200 hover:text-[var(--sun)] transition-colors break-all"><Mail size={14} /> {p.email}</a>
            </div>
          ))}
          <div className="sm:col-span-2 flex items-start gap-2 text-slate-300">
            <MapPin size={16} className="mt-1 shrink-0 text-[var(--sun)]" />
            <span>National Head Office: {CONTACT.office} · <a href={CONTACT.hotlineHref} className="text-white hover:text-[var(--sun)]" data-testid="footer-hotline">{CONTACT.hotline}</a></span>
          </div>
        </div>
      </div>
      <p aria-hidden className="mt-16 font-display font-black uppercase leading-[0.8] text-[17vw] lg:text-[13rem] tracking-tight text-outline select-none">
        Solar+Batteries
      </p>
      <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-sm text-slate-400">
        <span>© {new Date().getFullYear()} Carwash Solar Advisers · {CONTACT.web}</span>
        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white transition-colors">Staff login</Link>
      </div>
    </div>
  </footer>
);
